"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toolbar = Toolbar;
var React = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _jsxRuntime = require("react/jsx-runtime");
const ToolbarRoot = (0, _styles.styled)('div', {
  name: 'MuiChartsToolbar',
  slot: 'Root'
})(({
  theme
}) => ({
  flex: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  gap: theme.spacing(0.25),
  padding: theme.spacing(0.5),
  minHeight: 44,
  boxSizing: 'border-box',
  border: `1px solid ${(theme.vars || theme).palette.divider}`,
  borderRadius: 4
}));
function Toolbar({
  children
}) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ToolbarRoot, {
    children: children
  });
}